import { call, put, takeLatest } from 'redux-saga/effects';

import { spacerError, spacerRequest, spacerUpdateStore } from './spacerActions.js';
import { updateSpacerApiCall } from './spacerAPI.js';

function* updateSpacerSaga({ payload }) {
  try {
    yield call(updateSpacerApiCall, payload);
    yield put(spacerUpdateStore());
  } catch (error) {
    yield put(spacerError(error.Message ? error.Message : error.toString()));
  }
}

export function* spacerWatcher() {
  yield takeLatest(spacerRequest.type, updateSpacerSaga);
}
